<template>
  <v-row no-gutters>
    <v-col class="d-flex flex-wrap mb-4" cols="12">
      <div>
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 4 : 8"
            class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
            height="60"
            width="60"
            :class="{ selected: selectedDesign === '' }"
            @click="chooseDesign('')"
          >
            <v-icon color="#222" size="32">mdi-cancel</v-icon>
          </v-card>
        </v-hover>
      </div>
      <div v-for="(item, index) in designObject" :key="index">
        <v-hover v-slot="{ hover }">
          <v-card
            :class="{ selected: selectedDesign === item.value }"
            :elevation="hover ? 4 : 8"
            class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
            height="60"
            width="60"
            @click="chooseDesign(item.value)"
          >
            <img
              :alt="item.value"
              :src="item.img"
              class="rounded-0"
              :class="{ filterwhite: selectedDesign === item.value }"
              width="25"
            />
          </v-card>
        </v-hover>
      </div>
    </v-col>

    <v-col class="d-flex align-center grey--text" cols="12">
      {{ $t("dots_color") }}
      <v-divider class="mx-2" />
    </v-col>

    <v-col cols="12" md="6">
      <v-switch v-model="bgSwitch" :label="$t('gradient_color')" />
    </v-col>
    <template v-if="bgSwitch">
      <v-col class="pa-2" cols="12" md="6">
        <v-radio-group
          v-model="options.cornersDotOptions.gradient.type"
          class="ma-0"
          row
          @change="$emit('update', true)"
        >
          <v-radio :label="$t('linear')" value="linear" />
          <v-radio :label="$t('radial')" value="radial" />
        </v-radio-group>
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-slider
          v-model="computedRotation"
          append-icon="mdi-rotate-360"
          :label="$t('color_rotation')"
          max="360"
          min="0"
          thumb-label
          track-color="grey"
          @input="$emit('update', true)"
        >
          <template v-slot:thumb-label="{ value }">
            <div
              class="d-flex align-center justify-center"
              style="
                width: 20px;
                height: 20px;
                background-color: rgba(12, 15, 26, 0.7);
                border-radius: 50%;
              "
            >
              {{ value }}°
            </div>
          </template>
        </v-slider>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <color-picker
          v-model="options.cornersDotOptions.gradient.colorStops[0].color"
          :label="$t('first_color')"
          @input="$emit('update', true)"
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <color-picker
          v-model="options.cornersDotOptions.gradient.colorStops[1].color"
          :label="$t('second_color')"
          @input="$emit('update', true)"
        />
      </v-col>
    </template>

    <v-col v-else class="pa-2" cols="12" md="6">
      <color-picker
        v-model="options.cornersDotOptions.color"
        :label="$t('dots_color_label')"
        @input="
          options.cornersDotOptions.gradient = null;
          $emit('update', true);
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrCodeEye",

  components: { ColorPicker },

  props: {
    value: Object,
  },

  data: () => ({
    bgSwitch: false,
designObject: [
  { value: "vortex", img: "/media/eye/vortex.svg" },
    { value: "sparkle_dot", img: "/media/eye/sparkle_dot.svg" },
    { value: "9-dots-fat", img: "/media/eye/9-dots-fat.svg" },
  { value: "elastic", img: "/media/eye/elastic.svg" },
  { value: "square", img: "/media/eye/square.svg" },
  { value: "flurry", img: "/media/eye/flurry.svg" },
  { value: "rounded", img: "/media/eye/rounded.svg" },
  { value: "sun", img: "/media/eye/sun.svg" },
  { value: "star", img: "/media/eye/star.svg" },
  { value: "sparkle", img: "/media/eye/sparkle.svg" },
  { value: "plus", img: "/media/eye/plus.svg" },
  { value: "special-diamond", img: "/media/eye/diamond.svg" },
  { value: "sdoz", img: "/media/eye/sdoz.svg" },
  { value: "drop_in", img: "/media/eye/drop_in.svg" },
  { value: "drop", img: "/media/eye/drop.svg" },
  { value: "dropeye", img: "/media/eye/dropeye.svg" },
  { value: "circle", img: "/media/eye/circle.svg" },
  { value: "diagonal", img: "/media/eye/diagonal.svg" },
  { value: "bruised", img: "/media/eye/bruised.svg" },
  { value: "extra-rounded", img: "/media/eye/extra-rounded.svg" },
  { value: "classy", img: "/media/eye/classy.svg" },
  { value: "classy-rounded", img: "/media/eye/classy-rounded.svg" },
  { value: "heart", img: "/media/eye/heart.svg" },
  { value: "shake", img: "/media/eye/shake.svg" },
  { value: "blob", img: "/media/eye/blob.svg" },
  { value: "ellipse", img: "/media/eye/ellipse.svg" },
  { value: "cross", img: "/media/eye/cross.svg" },
  { value: "danger", img: "/media/eye/danger.svg" },
  { value: "diamond", img: "/media/eye/diamond.svg" },
  { value: "dots", img: "/media/eye/dots.svg" },
  { value: "flower", img: "/media/eye/flower.svg" },
  { value: "x", img: "/media/eye/x.svg" },
],
    rotation: 0,
    selectedDesign: null,
  }),

  computed: {
    // gradientKey() {
    //   if (!this.bgSwitch || !this.options.cornersDotOptions.gradient) {
    //     return "no-gradient";
    //   }
    //   const g = this.options.cornersDotOptions.gradient;
    //   return `gradient-${g.colorStops[0].color}-${g.colorStops[1].color}-${g.rotation}-${g.type}`;
    // },
    // firstGradientColor: {
    //   get() {
    //     return (
    //       (this.bgSwitch &&
    //         this.options.cornersDotOptions.gradient?.colorStops?.[0]?.color) ||
    //       "red"
    //     );
    //   },
    //   set(val) {
    //     if (this.bgSwitch && this.options.cornersDotOptions.gradient) {
    //       this.options.cornersDotOptions.gradient.colorStops[0].color = val;
    //       this.$emit("update", true);
    //       this.$forceUpdate();
    //     }
    //   },
    // },

    // secondGradientColor: {
    //   get() {
    //     return (
    //       (this.bgSwitch &&
    //         this.options.cornersDotOptions.gradient?.colorStops?.[1]?.color) ||
    //       "#000000"
    //     );
    //   },
    //   set(val) {
    //     if (this.bgSwitch && this.options.cornersDotOptions.gradient) {
    //       this.options.cornersDotOptions.gradient.colorStops[1].color = val;
    //       this.$emit("update", true);
    //       this.$forceUpdate();
    //     }
    //   },
    // },
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedRotation: {
      get() {
        return this.rotation;
      },
      set(val) {
        this.rotation = val;
        if (this.options.cornersDotOptions.gradient) {
          this.options.cornersDotOptions.gradient.rotation =
            (val * Math.PI) / 180;
        }
        this.$emit("update", true);
      },
    },
  },

  watch: {
    bgSwitch(val) {
      if (val) {
        if (!this.options.cornersDotOptions.gradient) {
          const baseColor = this.options.cornersDotOptions.color || "#001554";
          this.options.cornersDotOptions.gradient = {
            type: "linear",
            rotation: 0,
            colorStops: [
              { offset: 0, color: baseColor },
              { offset: 1, color: baseColor },
            ],
          };
        }
      } else {
        this.options.cornersDotOptions.gradient = null;
        if (!this.options.cornersDotOptions.color) {
          this.options.cornersDotOptions.color = "#001554";
        }
      }
      this.$emit("update", true);
    },
  },

  methods: {
    chooseDesign(value) {
      this.selectedDesign = value;
      this.options.cornersDotOptions.type = value || null;
      this.$emit("update");
    },
    // updateColor(index, value) {
    //   if (this.options.cornersDotOptions.gradient) {
    //     this.options.cornersDotOptions.gradient.colorStops[index].color = value;
    //     if (index === 0) this.tempColor1 = value;
    //     else this.tempColor2 = value;
    //     this.$emit("update", true);
    //   }
    // },
  },
};
</script>

<style scoped></style>
